export default __webpack_public_path__ + "static/media/info-cirlce.d5050e36.svg";